import Client from "shopify-buy/index.unoptimized.umd";
import { fetch as fetchPolyfill } from "whatwg-fetch";
import { createClient } from "contentful";
import Logger from "../utils/logger";
import HatchService from "./hatch-service";
import { isNull } from "lodash";

const TAG = "ApiClient";
let apiClient = null;
let shopifyApiClient = null;
let zendeskApiClient = null;

export const initializeApiClient = (store) => {
  const getAccessToken = () => {
    return isNull(store.getState().user.data)
      ? null
      : store.getState().user.data.token;
  };

  const getRefreshToken = () => {
    return store.getState().user.refreshToken;
  };

  const apiConfig = {
    baseURL: process.env.REACT_APP_HATCH_SERVICE_URL,
    getAccessToken,
    getRefreshToken,
    logger: (message) => Logger.d(TAG, message),
  };

  apiClient = HatchService.create(apiConfig);

  Logger.d(TAG, "API client initialized");
};

const get = () => apiClient;

export const initializeShopifyApiClient = () => {
  shopifyApiClient = Client.buildClient(
    {
      storefrontAccessToken: process.env.REACT_APP_STOREFRONT_ACCESS_TOKEN,
      domain: process.env.REACT_APP_SHOPIFY_STORE,
    },
    fetchPolyfill
  );

  Logger.d(TAG, "Shopify API client initialized");
};

const getShopify = () => shopifyApiClient;

export const initializeZendeskApiClient = () => {
  zendeskApiClient = HatchService.createZendeskEndpoints();

  Logger.d(TAG, "Zendesk API client initialized");
};

export const getZendesk = () => zendeskApiClient;

const contentfulApiClientOptions = {
  space: process.env.REACT_APP_CONTENTFUL_SPACE,
  accessToken: process.env.REACT_APP_CONTENTFUL_API_KEY,
};

export const getContentful = () => {
  if (process.env.REACT_APP_CONTENTFUL_PREVIEW_API_KEY) {
    // Use the Contentful preview API (drafts included)
    return createClient({
      ...contentfulApiClientOptions,
      accessToken: process.env.REACT_APP_CONTENTFUL_PREVIEW_API_KEY,
      host: process.env.REACT_APP_CONTENTFUL_HOST,
    });
  }

  // Use the Contentful delivery API (drafts hidden)
  return createClient(contentfulApiClientOptions);
};

const api = {
  get,
  getShopify,
  getZendesk,
  getContentful,
};

export default api;
